/* Plan check reference */
export interface PlanCheckReference {
    basic_part: PlanCheckBasicReference[];
    detail_part: PlanCheckDetailReference[];
}

export const mapPlanCheckReference = (data: any): PlanCheckReference => {
    if (!data) {
        throw new Error("Invalid Plan check refernce type");
    }

    const response: PlanCheckReference = {
        basic_part: Array.isArray(data.basic_part) ? mapPlanCheckBasicReferences(data.basic_part) : [],
        detail_part: Array.isArray(data.detail_part) ? mapPlanCheckDetailReferences(data.detail_part) : [],
    };

    return response;
};

/* Basic Reference */
export interface PlanCheckBasicReference {
    id: number;
    item_code: string;
    comment: string;
}

export const mapPlanCheckBasicReference = (data: any): PlanCheckBasicReference => {
    if (!data) {
        throw new Error("Invalid Plan check basic reference type");
    }

    const response: PlanCheckBasicReference = {
        id: data.id,
        item_code: data.item_code,
        comment: data.comment,
    };

    return response;
};

export const mapPlanCheckBasicReferences = (data: any[]): PlanCheckBasicReference[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid plan check basic reference data");
    }

    return data.map(mapPlanCheckBasicReference);
};

/* Detail Reference */
export interface PlanCheckDetailReference {
    id: number;
    part_number: string;
    part_title: string;
    item_list: PlanCheckBasicReference[];
}

export const mapPlanCheckDetailReference = (data: any): PlanCheckDetailReference => {
    if (!data) {
        throw new Error("Invalid Plan check detail reference type");
    }

    const response: PlanCheckDetailReference = {
        id: data.id,
        part_number: data.part_number,
        part_title: data.part_title,
        item_list: Array.isArray(data.item_list) ? mapPlanCheckBasicReferences(data.item_list) : [],
    };

    return response;
};

export const mapPlanCheckDetailReferences = (data: any[]): PlanCheckDetailReference[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid plan check detail reference data");
    }

    return data.map(mapPlanCheckDetailReference);
};